export default class SignupData {
  constructor () {
    this.fname = ''
    this.lname = ''
    this.email = ''
    this.password = ''
    this.password_confirm = ''
    this.org_name = ''
    this.org_website = ''
    this.org_type = ''

    // this is only populated if we found an org (ex: lookup by website)
    this.org_orgid = ''
  }
}
